<template>
	<div style="background-color: #fafafa">
		<Header :isHome="false"></Header>
		<div class="container" v-if="data" style="padding: 7rem 0 3rem;" :style="{paddingTop:isMobile?'5rem':'7rem'}">
			<div class="row">
				<div class="col-3">
					<div class="box">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							<div style="display: flex;">
								<div :style="{backgroundImage: 'url('+data.avatar+')'}" class="avatar"></div>
							</div>
							<div style="font-size: 2rem;font-weight: bold;">{{data.username}}</div>
							<div style="display: flex;flex-wrap: wrap;align-items: center;justify-content: center;margin-top: 1rem;">
								<div v-for="(tag, tindex) in data.tags" :key="tindex" style="background-color: #f8f8f8;font-size: 0.7rem;margin-right:0.5rem;margin-bottom:0.5rem;
								padding:0.2rem 0.5rem">{{tag.name}}</div>
							</div>
							<!-- <div style="margin-top: 1rem;">
								<img src="../../assets/imgs/user/email.png" style="width: 1.5rem;height: 1.5rem;margin-right: 0.5rem;">
								<span style="text-decoration: underline;">{{data.email}}</span>
							</div> -->
							
							<!-- 个人中心按钮 -->
							<div style="width: 100%;padding-top: 1rem;">
								<!-- 申请成为供应商 -->
								<div class="btn-cyan-liner" style="width: 100%;height: 2.5rem;display: flex;align-items: center;justify-content: center;border-radius: 5rem;cursor: pointer;
										font-weight: 500;"
										@click="toapplysupplier" v-if="!data.provider">Apply Service Providers</div>
								<!-- <div class="btn-cyan-liner" style="width: 100%;height: 2rem;display: flex;align-items: center;justify-content: center;border-radius: 1rem;cursor: pointer;"
										@click="toapplysupplier">Apply for supplier</div> -->
								<!-- 供应商 -->
								<div class="btn-cyan-liner" style="width: 100%;height: 2.5rem;display: flex;align-items: center;justify-content: center;border-radius: 5rem;cursor: pointer;
										font-weight: 500;"
										@click="tosupplierdetail" v-if="data.provider">Service Providers home</div>
								<!-- 会员购买页 -->
								<div class="btn-gold-liner" style="width: 100%;height: 2.5rem;display: flex;align-items: center;justify-content: center;border-radius: 5rem;cursor: pointer;
										font-weight: 500;margin-top: 1rem;" @click="touserlevel">My membership</div>
							</div>
						</div>
					</div>
					
					<div class="box" style="padding: 0;margin-top: 1rem;" v-if="!isMobile">
						<div style="display: flex;flex-direction: column;padding: 1rem 0;">
							<div style="display: flex;align-items: center;padding: 0.5rem 2rem;cursor: pointer;" class="menu-hover" :class="{'menu-active':type==index}"
									 @click="type=index,$router.replace({ name: 'user', query: { type: index } })" v-for="(item, index) in userArr" :key="index">
								<div style="display: flex;align-items: center;flex: 1;">
									<img :src="type==index?require('../../assets/imgs/user/'+item+'-light.svg'):require('../../assets/imgs/user/'+item+'.svg')" class="type-img">
									<span class="type-text">{{item}}</span>
								</div>
							</div>
						</div>
					</div>
					
					<div v-else>
						<div style="display: flex;flex-wrap: nowrap;width: 100%;overflow: scroll;" class="noscrollbar">
							<div v-for="(item, mindex) in userArr" :key="mindex" style="cursor: pointer;">
								<div class="news-l-item" :class="{ 'news-l-item-active': mindex == type }" style="cursor: pointer;width: max-content;" @click="type = mindex,$router.replace({ name: 'user', query: { type: mindex } })">
									<img :src="type==mindex?require('../../assets/imgs/user/'+item+'-light.svg'):require('../../assets/imgs/user/'+item+'.svg')" class="type-img">
									<span class="type-text">{{item}}</span>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				<div class="col-9 box">
					<Notify v-if="type == 0"></Notify>
					<Topic v-if="type == 1"></Topic>
					<InquiryRecord v-if="type == 2"></InquiryRecord>
					<DemandCustomization v-if="type == 3"></DemandCustomization>
					<Reserve v-if="type == 4"></Reserve>
					<Demand v-if="type == 5"></Demand>
					<Collect v-if="type == 6"></Collect>
					<Focus v-if="type == 7"></Focus>
					<Profile v-if="type == 8"></Profile>
					<Password v-if="type == 9"></Password>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			
			import Notify from '/src/components/user/notify.vue'
			import Topic from '/src/components/user/topic.vue'
			import Reserve from '/src/components/user/reserve.vue'
			import Demand from '/src/components/user/demand.vue'
			import Collect from '/src/components/user/collect.vue'
			import Focus from '/src/components/user/focus.vue'
			import Profile from '/src/components/user/profile.vue'
			import Password from '/src/components/user/password.vue'
			import InquiryRecord from '/src/components/user/InquiryRecord.vue'
			import DemandCustomization from '/src/components/user/DemandCustomization.vue'
			export default {
				data() {
					return {
						type:0,
						data:null,
						isMobile: false,
						userArr: ['Notifications','Topics','Inquiry record','Customization','Reservations','My Demands','Collections','Followings','Profile','Password']
					}
				},
				components: {
					Header,
					Footer,
					InquiryRecord,
					Notify,
					Topic,
					Reserve,
					Demand,
					Collect,
					Focus,
					Profile,
					Password,
					DemandCustomization
				},
				methods: {
					getdata(){
						this.request({
							method: 'get',
							url: '/gci/user/info',
						}).then(res => {
							this.data = res.data
							if(res.status!=0){
								
								this.$bus.$emit('message', {
									type:3,
									msg:res.msg
								})
							}
							this.$bus.$emit('loading', false)
						}).catch(error => {
							console.error(error.response)
						})
					},
					toapplysupplier(){
						this.$router.push({name:'applysupplier'})
						// location.reload()
					},
					tosupplierdetail(){
						this.$router.push({name:'supplierdetail',query:{id:this.data.provider.id}})
					},
					touserlevel(){
						this.$router.push({name:'userlevel'})
					}
				},
				created() {
					this.$bus.$emit('loading', true)
				},
				mounted() {
					localStorage.getItem('isMobile') == 'null'?this.isMobile = false:this.isMobile = true
					this.type = this.$route.query.type
					this.getdata()
				}
			}
</script>

<style scoped lang="scss">
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 50%;
		width:5rem;height: 5rem;
	}
	.box{
		background-color: #fff;border-radius: 1rem;padding: 2rem;
	}
	.type-img{
		width:1.5rem;height: 1.5rem;margin-right: 0.5rem;
	}
	.type-text{
		font-size: 1rem;font-weight: 500;
	}
	
	.noscrollbar::-webkit-scrollbar{display: none;}
	
	.news-l-item{
		background-color: #fff;
		color: #333;
		font-size: 0.9rem;
		font-weight: bold;
		// padding: 0.5rem;
		border-radius: 0.2rem;
		margin-right: 1rem;
		border: 1px solid #E0E0E0;;
		margin-top: 1rem;
		display: flex;align-items: center;justify-content: center;
		// width: 6rem;
		// height: 2rem;
		padding: 0.5rem 1rem;
	}
	.news-l-item-active{
		background-color: #31ffda;color: #333;
		border:1px solid transparent
	}
	.menu-hover{
		background-color: #fff;
	}
	.menu-hover:hover{
		background-color: #fafafa;
	}
	.menu-active{
		background-color: #31ffda !important;
	}
	@media (max-width:767px) {
		.row{margin: 1rem;}
		.col-3{
			min-width: 100%;
			padding: 0;
		}
		.col-9{
			margin-top: 1rem;
			min-width: 100%;
		}
		.box{
			padding: 1rem;
		}
	}
</style>